import { EcosystemListingStub } from 'trellis-ecosystem';
import { buildListingUrl } from '../utils/navigation';
import { AutocompleteItem } from './AutocompleteItem';
import { SearchGroupItem } from './SearchGroupItem';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchOption({
  item,
  searchTerm
}) {
  switch (item.resultType) {
    case 'QUERY':
      return /*#__PURE__*/_jsx(AutocompleteItem, {
        keyword: searchTerm,
        suggestion: item.term,
        queryType: item.queryType,
        "aria-label": "search query"
      });
    case 'LISTING':
      return /*#__PURE__*/_jsx(EcosystemListingStub, {
        imageSrc: item.iconUrl || '',
        listingHref: buildListingUrl(item.slug),
        name: item.term || '',
        productType: item.productType || 'APP',
        providerName: item.providerName || ''
      });
    case 'CATEGORY':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm
      });
    case 'COLLECTION':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm
      });
    default:
      return null;
  }
}